// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__2o-cu","wrapper":"Overlay_wrapper__3D7zW"};